import ScheduleListSlice from '../../slices/online_class/schedule/ScheduleList';
import ScheduleDetailsSlice from '../../slices/online_class/schedule/ScheduleDetails';

const onlineClassReducer = {
    scheduleList: ScheduleListSlice,
    scheduleDetails: ScheduleDetailsSlice,
};

export default onlineClassReducer;
